module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_edit-802a4a93ef7a9d78aa6cd3fbd9a2cbb7.svg";